import { render } from "./NotesTab.vue?vue&type=template&id=e443024c"
import script from "./NotesTab.vue?vue&type=script&lang=js"
export * from "./NotesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__